import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'ngx-panel',
	templateUrl: './panel.component.html',
	styleUrls: ['./panel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NgxPanelComponent {
	constructor () {}
}
